import { State } from 'reactApp/modules/paidInfo/paidInfo.types';
import { RootState } from 'reactApp/store';
import { LoadingState } from 'reactApp/types/commonStates';
import { createSelector } from 'reselect';

const getPaidInfoState = (state: RootState) => state.paidInfo as State;

const getLoadingState = createSelector(
    getPaidInfoState,
    (state: State): LoadingState => ({
        isLoading: state.isLoading,
        isLoaded: state.isLoaded,
    })
);

const isUserWithoutPayment = createSelector(
    getPaidInfoState,
    getLoadingState,
    (state: State, loading: LoadingState): boolean => loading.isLoaded && state.paidExpires === 0 && state.trialExpires === 0
);

export const PaidInfoSelectors = {
    getLoadingState,
    isUserWithoutPayment,
};
